import { User } from '@/models/User';
import { birthday } from '@/support/Date';
export class Teacher extends User {
    constructor() {
        super(...arguments);
        this.$name = 'Teacher';
        this.$fillable = ['avatar', 'name', 'first_name', 'middle_name', 'last_name', 'dob', 'school', 'email', 'password', 'teacher', 'phone', 'roles', 'groups', 'parnassys_id'];
        this.filters = {
            role: 'teacher',
        };
    }
    setDobAttribute(value) {
        this.age = birthday(value);
        return value;
    }
    url() {
        return '/teachers/' + this.id;
    }
}
